import { render, staticRenderFns } from "./formularioRegistro.vue?vue&type=template&id=586ebe2c"
import script from "./formularioRegistro.vue?vue&type=script&lang=js"
export * from "./formularioRegistro.vue?vue&type=script&lang=js"
import style0 from "./formularioRegistro.vue?vue&type=style&index=0&id=586ebe2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports